<div class="flex-horizontal">
  <div class="month-year">{{getDate(date)}}</div>
  <ngx-overview-cell
    *ngFor="let day of days; trackBy: trackByFn"
    [date]="day.date"
    [isHeaderCell]="true"
  ></ngx-overview-cell>
</div>